var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-view"},[_c('video',{staticStyle:{"width":"100%","height":"100%"},attrs:{"controls":"","preload":"auto","poster":_vm.cover,"width":_vm.videoWidth,"height":_vm.videoHeight,"src":_vm.videoUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }